import React from 'react';
import { Star, Loader2 } from 'lucide-react';
import MenuPageShell from '../MenuPageShell';

const FeedbackPage = ({ lang, t, fbForm, setFbForm, fbErrs, setFbErrs, fbSent, setFbSent, fbLoading, setFbLoading, onBack }) => {
  const title = t.menuFeedback || '用戶意見';
  const L = (zh, zhCN, en, ja, ko) => lang==='en'?en:lang==='ja'?(ja||en):lang==='ko'?(ko||en):lang==='zh-CN'?zhCN:zh;
  const cats = [
    { k:'suggestion', zh:'功能建議', en:'Feature Suggestion', ja:'機能提案', ko:'기능 제안' },
    { k:'bug',        zh:'問題反映', en:'Bug Report',          ja:'不具合報告', ko:'버그 신고' },
    { k:'content',    zh:'內容錯誤', en:'Content Error',       ja:'内容エラー', ko:'내용 오류' },
    { k:'other',      zh:'其他',     en:'Other',               ja:'その他', ko:'기타' },
  ];
  const catLabel = (c) => lang==='en'?c.en:lang==='ja'?c.ja:lang==='ko'?c.ko:c.zh;
  const FL = {
    category:  L('類別 *',       '類别 *',       'Category *',           'カテゴリー *',            '카테고리 *'),
    name:      L('姓名 *',       '姓名 *',       'Name *',               'お名前 *',               '이름 *'),
    namePh:    L('你的名字',     '你的名字',     'Your name',            'お名前を入力',            '이름을 입력'),
    email:     L('電郵 *',       '电郵 *',       'Email *',              'メールアドレス *',        '이메일 *'),
    feedback:  L('意見內容 *',   '意见内容 *',   'Your Feedback *',      'ご意見・ご感想 *',        '의견 내용 *'),
    fbPh:      L('請告訴我們您的想法...','请告诉我们您的想法...','Tell us what you think...','ご意見をお聞かせください...','의견을 알려주세요...'),
    required:  L('必填',         '必填',         'Required',             '必須',                   '필수'),
    emailReq:  L('請填寫有效電郵','请填写有效邮箱','Valid email required', '有効なメールアドレスが必要','유효한 이메일 필요'),
    fbReq:     L('請填寫意見內容','请填写意见内容','Please enter your feedback','ご意見を入力してください','의견을 입력해주세요'),
    sendErr:   L('發送失敗，請稍後再試。','发送失败，请稍后再试。','Failed to send. Please try again.','送信失敗。もう一度お試しください。','전송 실패. 다시 시도해주세요.'),
    submit:    L('提交意見',     '提交意见',     'Submit Feedback',      '意見を送信',             '의견 제출'),
    sending:   L('發送中…',     '发送中…',      'Sending…',             '送信中…',                '전송 중…'),
    again:     L('再次填寫',     '再次填写',     'Submit Another',       'もう一度送る',            '다시 제출'),
    successSub:L('我們會盡快處理您的意見。','我们会尽快处理您的意见。',"We'll review it and get back to you if needed.",'できるだけ早く対応いたします。','검토 후 필요시 연락드리겠습니다.'),
  };
  const inp = { width:'100%', border:'1.5px solid #e2e8f0', borderRadius:12, padding:'11px 14px', fontSize:13, outline:'none', background:'white', boxSizing:'border-box', color:'#0f172a' };
  const lbl = { fontSize:12, fontWeight:700, color:'#374151', marginBottom:6, display:'block' };

  const submitFeedback = async () => {
    const e = {};
    if (!fbForm.name.trim()) e.name = true;
    if (!fbForm.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(fbForm.email)) e.email = true;
    if (!fbForm.message.trim()) e.message = true;
    setFbErrs(e);
    if (Object.keys(e).length) return;
    setFbLoading(true);
    try {
      const r = await fetch('/api/feedback', {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ name:fbForm.name.trim(), email:fbForm.email.trim(), category:fbForm.category, message:fbForm.message }),
      });
      if (r.ok) setFbSent(true);
      else setFbErrs({ submit:true });
    } catch { setFbErrs({ submit:true }); }
    setFbLoading(false);
  };

  return (
    <MenuPageShell title={title} icon={Star} onBack={onBack}>
      {fbSent ? (
        <div style={{ textAlign:'center', padding:'32px 16px' }}>
          <div style={{ fontSize:52, marginBottom:12 }}>🙏</div>
          <p style={{ fontSize:18, fontWeight:900, color:'#0f172a', margin:'0 0 8px' }}>
            {L('感謝您的意見！','感谢您的意见！','Thank you for your feedback!','ご意見ありがとうございます！','의견 감사합니다!')}
          </p>
          <p style={{ fontSize:13, color:'#64748b', margin:'0 0 20px' }}>{FL.successSub}</p>
          <button onClick={()=>{ setFbSent(false); setFbForm({ name:'', email:'', category:'suggestion', rating:0, message:'' }); }}
            style={{ background:'#f59e0b', color:'#0f172a', border:'none', borderRadius:12, padding:'11px 24px', fontWeight:900, fontSize:13, cursor:'pointer' }}>
            {FL.again}
          </button>
        </div>
      ) : (
        <div style={{ display:'flex', flexDirection:'column', gap:14 }}>
          <div>
            <label style={lbl}>{FL.category}</label>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:7 }}>
              {cats.map(c=>(
                <button key={c.k} onClick={()=>setFbForm({...fbForm,category:c.k})}
                  style={{ padding:'9px', borderRadius:10, border:fbForm.category===c.k?'none':'1.5px solid #e2e8f0', background:fbForm.category===c.k?'#f59e0b':'white', color:fbForm.category===c.k?'#0f172a':'#64748b', fontSize:12, fontWeight:700, cursor:'pointer', transition:'all 0.15s' }}>
                  {catLabel(c)}
                </button>
              ))}
            </div>
          </div>
          <div>
            <label style={lbl}>{FL.name}</label>
            <input value={fbForm.name} onChange={e=>setFbForm({...fbForm,name:e.target.value})}
              placeholder={FL.namePh}
              style={{ ...inp, borderColor:fbErrs.name?'#dc2626':'#e2e8f0' }}/>
            {fbErrs.name && <p style={{ fontSize:11, color:'#dc2626', margin:'4px 0 0' }}>{FL.required}</p>}
          </div>
          <div>
            <label style={lbl}>{FL.email}</label>
            <input type="email" value={fbForm.email} onChange={e=>setFbForm({...fbForm,email:e.target.value})}
              placeholder="your@email.com"
              style={{ ...inp, borderColor:fbErrs.email?'#dc2626':'#e2e8f0' }}/>
            {fbErrs.email && <p style={{ fontSize:11, color:'#dc2626', margin:'4px 0 0' }}>{FL.emailReq}</p>}
          </div>
          <div>
            <label style={lbl}>{FL.feedback}</label>
            <textarea value={fbForm.message} onChange={e=>setFbForm({...fbForm,message:e.target.value})} rows={5}
              placeholder={FL.fbPh}
              style={{ ...inp, resize:'vertical', fontFamily:'inherit', lineHeight:1.6, borderColor:fbErrs.message?'#dc2626':'#e2e8f0' }}/>
            {fbErrs.message && <p style={{ fontSize:11, color:'#dc2626', margin:'4px 0 0' }}>{FL.fbReq}</p>}
          </div>
          {fbErrs.submit && <p style={{ fontSize:12, color:'#dc2626', textAlign:'center' }}>{FL.sendErr}</p>}
          <button onClick={submitFeedback} disabled={fbLoading}
            style={{ background:'#f59e0b', color:'#0f172a', border:'none', borderRadius:13, padding:'13px', fontSize:14, fontWeight:900, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', gap:8, opacity:fbLoading?0.7:1 }}>
            {fbLoading ? <><Loader2 size={15} style={{animation:'spin 1s linear infinite'}}/>{FL.sending}</> : FL.submit}
          </button>
        </div>
      )}
    </MenuPageShell>
  );
};

export default FeedbackPage;
